import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DesktopErrorHandler } from '../services/errorHandler.service';
import { CompassStateModel, ClearSubscriptions, CommonService, ScoredSubscription, PatientStateModel, GetPatientById, GetGuidanceSubs, GetPatientResults, PatientEntity, PatientResult, DateUtil, Time, NetworkMember, PatientAlert,Provider, RefreshPatient, GuidanceSubscriptionModel, Config, PatientEndpoint, ProviderEndpointStateModel, GetPatientEndpoints, Phone, Address, FamilyPatient, sanitizeIdentifier } from 'huddyapi';
import { EditPatientDialog } from '../components/edit-patient-dialog/edit-patient-dialog.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { CommunityConfigService } from '../services/community-config.service';



@Component({
  selector: 'patient-detail',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.scss']
})
export class PatientPageComponent implements OnInit{
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;
  @Select(state => state.patientState) patientState$: Observable<PatientStateModel>;
  @Select(state => state.providerEndpointState) providerEndpointState$: Observable<ProviderEndpointStateModel>;
  @Select(state => state.guidanceSubscriptions) guidanceSubscriptionState$: Observable<GuidanceSubscriptionModel>;
  patientSubscription : Subscription;
  guidanceSubSubscription : Subscription;
  patient : PatientEntity;
  tabIndex : number;
  results : PatientResult;
  latestScoredCompasses: ScoredSubscription[];
  dispatchedScoredCompasses : boolean = false;
  scoredCompasses : ScoredSubscription[];
  providerSubscription: Subscription;
  providerEndpointsubscription : Subscription;
  patientEndpoints : PatientEndpoint[];
  providers: Provider[];
  @Select(state => state.compassState.providers) providers$: Observable<Provider[]>;
  private routeSub:any;



  constructor(
    private store: Store,
    private config: Config,
    private errorHandler: DesktopErrorHandler,
    private route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    
    this.matIconRegistry.addSvgIcon('red',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/red_alert.svg'));
    this.matIconRegistry.addSvgIcon('yellow',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/yellow_alert.svg'));
    this.matIconRegistry.addSvgIcon('green',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/green_alert.svg'));
   
  }

  public ngOnDestroy() {
    this.routeSub.unsubscribe();
    this.patientSubscription.unsubscribe();
    this.guidanceSubSubscription.unsubscribe();

  }
  
  

  ngOnInit(): void {
    
    const patientId: number = parseInt(this.route.snapshot.paramMap.get('patientId'));
    //this.scoredCompasses = [];
    this.dispatchedScoredCompasses = false;
    const defaultTabIndex =  0;
   this.setTab(defaultTabIndex);
   this.routeSub = this.router.events.subscribe((event) => {
    console.log(event);
    if (event instanceof NavigationStart) {
      this.clearState();
    }
  });
   this.patientSubscription = this.patientState$.subscribe((patientState: PatientStateModel) => {
      if (patientState && patientState.currentPatient && patientState.currentPatient.id === patientId) {
        this.patient = patientState.currentPatient;
        if (patientState.currentResults) {
          console.log('Current results', patientState.currentResults);
          this.results = patientState.currentResults;
          let today : number = new Time().getEpochDay();
          console.log('Firing refresh patient', this.patient.userId,  today - 29, today);
          this.store.dispatch(new RefreshPatient(this.patient.userId,  today - 29, today));
        }
        if (this.patient && this.patient.userId && !this.dispatchedScoredCompasses) {
          let action = new GetGuidanceSubs(true, false, this.patient.userId);
          this.dispatchedScoredCompasses = true;
          this.store.dispatch(action);
          this.store.dispatch(new GetPatientEndpoints(this.patient.id));
        }
        console.log('Current patient', this.patient);
      }
    });

    this.guidanceSubSubscription = this.guidanceSubscriptionState$.subscribe((guidanceSubModel: GuidanceSubscriptionModel) => {
      if (this.patient) {
        if (guidanceSubModel && guidanceSubModel.scoredSubscriptions) {
          this.scoredCompasses = guidanceSubModel.scoredSubscriptions.sort(this.compareScoredSubscriptions);
          this.latestScoredCompasses = [].concat(this.scoredCompasses);
          if (this.latestScoredCompasses.length > 3) {
            this.latestScoredCompasses.splice(3);
          }
        }
        console.log('Scored compasses', this.scoredCompasses);
      }
    });  

    

    this.providerEndpointsubscription = this.providerEndpointState$.subscribe((providerEndpointStateModel: ProviderEndpointStateModel) => {
      if (this.patient) {
        if (providerEndpointStateModel && providerEndpointStateModel.patientEndpoints) {
          this.patientEndpoints = providerEndpointStateModel.patientEndpoints;
          this.setTab((this.patientEndpoints.length > 0) ? 5 : 2);
        }
        console.log('Patient Endpoints', this.patientEndpoints);
      }
    }); 
    
    let today : number = new Time().getEpochDay();

    this.store.dispatch( new GetPatientById(patientId));
    this.store.dispatch( new GetPatientResults(patientId, today - 29, today ));
    this.providerSubscription = this.providers$.subscribe((providers: Provider[]) => {
      this.providers = providers;
    });
  }

  compareScoredSubscriptions(s1: ScoredSubscription, s2: ScoredSubscription) {
    if ( s1.lastAssessmentDay < s2.lastAssessmentDay ){
      return 1;
    }
    if ( s1.lastAssessmentDay > s2.lastAssessmentDay ){
      return -1;
    }
    return 0;
  }

  toDateOfBirthFromEpochDay(epochDay : number) {
    if (epochDay) {
      return DateUtil.fromEpochDay(epochDay).getDateDisplay();
    }
    return new Time().getDateDisplay();
  }

  setTab(tabIndex: number) {
    this.tabIndex = tabIndex;
  }

  cleanupIdentifier(patient : PatientEntity) {
    if (patient.familyRelationships && patient.identifier && patient.identifier.length > 6) {
      const familyIdentifiers : string[] = patient.familyRelationships.map(fr => fr.familyIdentifier);
      let firstSix : string = patient.identifier.substring(0, 6);
      let familyIdentifier : string = familyIdentifiers.find(fid => fid.startsWith(firstSix));
      if (familyIdentifier) {
        return sanitizeIdentifier(familyIdentifier, patient.identifier);
      }
    }
    return '';
  }

  cleanupFamilyIdentifier(familyIdentifier : string) {
    return sanitizeIdentifier(familyIdentifier, familyIdentifier);
  }

  onEdit() {
    this.dialog.open(EditPatientDialog, {
      width: '600px',
      height: '575px',
      data: {
        patient: this.patient,
        fromFamily : false
      }
    });
  }

  getProviderName() : string {
    if (this.providers && this.providers.length > 1 && this.patient) {
      let names : string[] = this.providers.filter(p => p.id === this.patient.providerId).map(p => p.name);
      if (names.length > 0) {
        return '(' + names[0] + ') ';
      }
    }
    return '';
  }

  getColorFromName(name : string, fromPatient? :boolean) : string {
    let ret : string = '#DAC7FD';
    if (fromPatient) {
      name = 'p';
      if (this.patient && this.patient.lastName) {
        name = this.patient.lastName;
      }
    }
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  getPatientInitials() : string {
    let ret : string = 'p';
    if (this.patient) {
      if (this.patient.firstName && this.patient.firstName.indexOf('null') === -1) {
        ret = this.patient.firstName.substring(0,1);
        if (this.patient.lastName) {
          ret = ret + this.patient.lastName.substring(0, 1);
        }
        ret = ret.toLowerCase();
      } else {
        ret = this.patient.username.substring(0,1).toLowerCase();
      }
    }
    return ret;
  }

  getAlertIcon(patientAlert : PatientAlert) : string {
    return   patientAlert.icon.toLowerCase() ;
  }

  getPatientAlertDate(patientAlert : PatientAlert) : string {
    let d = new Date(0);
    d.setUTCSeconds(patientAlert.epochTimeSecs);
    return   new Time(d.toISOString()).getDateDisplay() ;
  }

  epochDayToDate(epochDay: number) : string {
    if (epochDay <= 0) {
      return '';
    }
    return   Time.fromEpochDay(epochDay).getDateDisplay() ;
  }


  getLetters(name: string): string {
    name = name.trim();
    return name.substring(0, 1);
  }

  gotoCompasses() {
    this.tabIndex = 0;
  }

  showAssessment(subscriptionId : number, lastAssessmentDay : number) {
    if (CommonService.jwt && CommonService.jwt.length > 7 && lastAssessmentDay > 0) {
      let token : string = CommonService.jwt.substring(7);
      let url : string = this.config.getEndpoint() + '/report-for-subscription?subscriptionId=' + subscriptionId + '&access_token=' + token;
      window.open(url);      
    }
  }

  getPatientName() : string {
    let ret : string = this.patient.firstName + ' ' + this.patient.lastName;
    if (!ret || ret.indexOf("null ") > -1) {
      ret = this.patient.username;
    }
    return ret;
  }

  clearState() {
    console.log('CLEARING STATE');
    this.store.dispatch(new ClearSubscriptions());
    this.patient = null;
    this.tabIndex = (this.shouldShowTimeline()) ? 5 : 2;
    this.results = null;
    this.latestScoredCompasses = [];
    this.patientEndpoints = [];
    this.scoredCompasses  = [];
  }

  isLoading() {
    return !this.patient || this.patient === null;
  }

  shouldShowTimeline() : boolean {
    return  this.patientEndpoints && this.patientEndpoints.length > 0;   
  }

  getLastAuthDate(unixTime : number) {
    if (!unixTime)
      return '';
    return new Date(unixTime).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"});
  }

  getAddress(address : Address) : string {
    return this.trim(address.street1) + ' ' + 
    this.trim(address.street2) + ' ' + 
    this.trim(address.city) + ' ' + 
    this.trim(address.state) + ' ' + 
    this.trim(address.postalCode) + ' ' + 
    this.trim(address.country);
  }

  getPhone(phone : Phone) : string {
    let ret : string = 'Unknown';

    if (phone.number) {
    const raw : string = this.trim(phone.number).replace(/\D/g, '');
    ret = '(' + this.trim(phone.area) + ') ' + raw.substring(0, 3) + '-' + raw.substring(3);
    }

    return ret;
  }

  getFamilyRelationship(fr : FamilyPatient) : string {
    return this.cleanupFamilyIdentifier(fr.familyIdentifier) + ' (' + fr.relationship + ')';
  }


  trim(s : string) : string {
    return (!s || s == null || s === 'null') ? '' : s.trim();
  }

  goToFamily(fr : FamilyPatient) {
    this.router.navigateByUrl('/family/' + fr.familyId);
  }



}
